var map = {
	"./agneau.png": 2844,
	"./carotte.png": 1435,
	"./cassava.png": 7320,
	"./citrouille.png": 3178,
	"./epluchures.png": 4636,
	"./grenade.png": 1085,
	"./huileolive.png": 1989,
	"./levure.png": 951,
	"./lin.png": 387,
	"./myrtilles.png": 8849,
	"./pois.png": 1372,
	"./poulet.png": 2140,
	"./riz.png": 3098,
	"./saumon.png": 4072
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8223;